
import React from 'react';
import { Link } from 'react-router-dom';

const Government = () => {
  return (
    <>
      {/* Page Header */}
      <section className="relative py-24 bg-cover bg-center bg-no-repeat" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?auto=format&fit=crop&w=1920&q=80')" }}>
        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Government Jobs</h1>
          <div className="flex items-center text-white text-lg">
            <Link to="/" className="hover:text-primary-300 transition-colors">Home</Link>
            <i className="fas fa-chevron-right mx-3"></i>
            <span className="text-primary-300">Government Jobs</span>
          </div>
        </div>
      </section>

      {/* Government Jobs Intro Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Public Sector Opportunities</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">Explore rewarding career opportunities in government and public sector organizations across UAE</p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <p className="text-gray-700 leading-relaxed">Government jobs in the UAE offer competitive salaries, excellent benefits, and job security. The UAE government is committed to increasing Emiratization and providing opportunities for both nationals and expatriates in various departments and ministries.</p>
              <p className="text-gray-700 leading-relaxed">JobsDriver brings you the latest government job openings from federal and local government entities, regulatory authorities, and public sector organizations.</p>

              <div className="space-y-6 mt-8">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center">
                    <i className="fas fa-shield-alt text-primary-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Job Security</h4>
                    <p className="text-gray-600">Stable employment with long-term career prospects</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center">
                    <i className="fas fa-hand-holding-usd text-primary-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Competitive Benefits</h4>
                    <p className="text-gray-600">Attractive salary packages and comprehensive benefits</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center">
                    <i className="fas fa-chart-line text-primary-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Career Growth</h4>
                    <p className="text-gray-600">Clear career progression paths and development opportunities</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:order-last">
              <img src="https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?auto=format&fit=crop&w=600&q=80" alt="UAE Government Building" className="w-full h-auto rounded-lg shadow-lg" />
            </div>
          </div>
        </div>
      </section>

      {/* Government Entities Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Top Government Entities</h2>
            <p className="text-xl text-gray-600">Explore opportunities with leading government organizations</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {/* Entity 1 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center">
              <div className="mb-4">
                <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=120&h=120&q=80" alt="Dubai Municipality Logo" className="w-20 h-20 mx-auto rounded-lg" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Dubai Municipality</h3>
              <p className="text-gray-600 text-sm mb-4 line-clamp-3">Responsible for urban planning, construction supervision, and environmental regulation in Dubai.</p>
              <div className="mb-4">
                <span className="inline-block bg-primary-100 text-primary-700 text-xs font-medium px-3 py-1 rounded-full">25+ Open Positions</span>
              </div>
              <Link to="/jobs?organization=dubai-municipality" className="inline-block w-full px-4 py-2 border border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-medium rounded-lg transition-colors duration-200 text-sm">View Jobs</Link>
            </div>

            {/* Entity 2 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center">
              <div className="mb-4">
                <img src="https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=120&h=120&q=80" alt="RTA Logo" className="w-20 h-20 mx-auto rounded-lg" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Roads and Transport Authority</h3>
              <p className="text-gray-600 text-sm mb-4 line-clamp-3">Responsible for planning and executing transport and traffic projects in Dubai.</p>
              <div className="mb-4">
                <span className="inline-block bg-primary-100 text-primary-700 text-xs font-medium px-3 py-1 rounded-full">18+ Open Positions</span>
              </div>
              <Link to="/jobs?organization=rta" className="inline-block w-full px-4 py-2 border border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-medium rounded-lg transition-colors duration-200 text-sm">View Jobs</Link>
            </div>

            {/* Entity 3 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center">
              <div className="mb-4">
                <img src="https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?auto=format&fit=crop&w=120&h=120&q=80" alt="DEWA Logo" className="w-20 h-20 mx-auto rounded-lg" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Dubai Electricity & Water Authority</h3>
              <p className="text-gray-600 text-sm mb-4 line-clamp-3">Provides electricity and water services to residents and businesses in Dubai.</p>
              <div className="mb-4">
                <span className="inline-block bg-primary-100 text-primary-700 text-xs font-medium px-3 py-1 rounded-full">30+ Open Positions</span>
              </div>
              <Link to="/jobs?organization=dewa" className="inline-block w-full px-4 py-2 border border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-medium rounded-lg transition-colors duration-200 text-sm">View Jobs</Link>
            </div>

            {/* Entity 4 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center">
              <div className="mb-4">
                <img src="https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&w=120&h=120&q=80" alt="ADNOC Logo" className="w-20 h-20 mx-auto rounded-lg" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Abu Dhabi National Oil Company</h3>
              <p className="text-gray-600 text-sm mb-4 line-clamp-3">State-owned oil company responsible for oil production and operations in Abu Dhabi.</p>
              <div className="mb-4">
                <span className="inline-block bg-primary-100 text-primary-700 text-xs font-medium px-3 py-1 rounded-full">45+ Open Positions</span>
              </div>
              <Link to="/jobs?organization=adnoc" className="inline-block w-full px-4 py-2 border border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-medium rounded-lg transition-colors duration-200 text-sm">View Jobs</Link>
            </div>

            {/* Entity 5 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center">
              <div className="mb-4">
                <img src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=120&h=120&q=80" alt="ADIA Logo" className="w-20 h-20 mx-auto rounded-lg" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Abu Dhabi Investment Authority</h3>
              <p className="text-gray-600 text-sm mb-4 line-clamp-3">Sovereign wealth fund owned by the Emirate of Abu Dhabi, investing funds on behalf of the Government.</p>
              <div className="mb-4">
                <span className="inline-block bg-primary-100 text-primary-700 text-xs font-medium px-3 py-1 rounded-full">15+ Open Positions</span>
              </div>
              <Link to="/jobs?organization=adia" className="inline-block w-full px-4 py-2 border border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-medium rounded-lg transition-colors duration-200 text-sm">View Jobs</Link>
            </div>

            {/* Entity 6 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center">
              <div className="mb-4">
                <img src="https://images.unsplash.com/photo-1497486751825-1233686d5d80?auto=format&fit=crop&w=120&h=120&q=80" alt="Ministry of Education Logo" className="w-20 h-20 mx-auto rounded-lg" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Ministry of Education</h3>
              <p className="text-gray-600 text-sm mb-4 line-clamp-3">Responsible for the education system and policy in the United Arab Emirates.</p>
              <div className="mb-4">
                <span className="inline-block bg-primary-100 text-primary-700 text-xs font-medium px-3 py-1 rounded-full">22+ Open Positions</span>
              </div>
              <Link to="/jobs?organization=ministry-of-education" className="inline-block w-full px-4 py-2 border border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-medium rounded-lg transition-colors duration-200 text-sm">View Jobs</Link>
            </div>

            {/* Entity 7 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center">
              <div className="mb-4">
                <img src="https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?auto=format&fit=crop&w=120&h=120&q=80" alt="Ministry of Health Logo" className="w-20 h-20 mx-auto rounded-lg" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Ministry of Health & Prevention</h3>
              <p className="text-gray-600 text-sm mb-4 line-clamp-3">Responsible for implementing healthcare policy and regulating healthcare services.</p>
              <div className="mb-4">
                <span className="inline-block bg-primary-100 text-primary-700 text-xs font-medium px-3 py-1 rounded-full">35+ Open Positions</span>
              </div>
              <Link to="/jobs?organization=ministry-of-health" className="inline-block w-full px-4 py-2 border border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-medium rounded-lg transition-colors duration-200 text-sm">View Jobs</Link>
            </div>

            {/* Entity 8 */}
            <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 text-center">
              <div className="mb-4">
                <img src="https://images.unsplash.com/photo-1593115057322-e94b77572f20?auto=format&fit=crop&w=120&h=120&q=80" alt="Dubai Police Logo" className="w-20 h-20 mx-auto rounded-lg" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Dubai Police</h3>
              <p className="text-gray-600 text-sm mb-4 line-clamp-3">Law enforcement agency responsible for policing the city of Dubai.</p>
              <div className="mb-4">
                <span className="inline-block bg-primary-100 text-primary-700 text-xs font-medium px-3 py-1 rounded-full">28+ Open Positions</span>
              </div>
              <Link to="/jobs?organization=dubai-police" className="inline-block w-full px-4 py-2 border border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-medium rounded-lg transition-colors duration-200 text-sm">View Jobs</Link>
            </div>
          </div>

          <div className="text-center mt-12">
            <Link to="/government-entities" className="inline-block px-8 py-3 border-2 border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-semibold rounded-lg transition-all duration-200 transform hover:scale-105">View All Government Entities</Link>
          </div>
        </div>
      </section>

      {/* Latest Government Jobs Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Latest Government Job Openings</h2>
            <p className="text-xl text-gray-600">Recently posted government and public sector jobs</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Job 1 */}
            <div className="bg-white border border-gray-200 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=80&h=80&q=80" alt="Dubai Municipality Logo" className="w-12 h-12 rounded-lg" />
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">Environmental Engineer</h3>
                      <div className="flex items-center text-gray-600 text-sm">
                        <i className="fas fa-building mr-1"></i> Dubai Municipality
                      </div>
                    </div>
                  </div>
                  <span className="inline-block bg-green-100 text-green-800 text-xs font-medium px-2 py-1 rounded-full">Full Time</span>
                </div>

                <div className="space-y-2 mb-4">
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-map-marker-alt mr-2 w-4"></i> Dubai, UAE
                  </div>
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-money-bill-wave mr-2 w-4"></i> AED 15,000 - 20,000
                  </div>
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-clock mr-2 w-4"></i> Posted 3 days ago
                  </div>
                </div>

                <p className="text-gray-700 text-sm mb-4 line-clamp-2">Dubai Municipality is seeking an experienced Environmental Engineer to join our Environmental Department...</p>

                <div className="flex items-center justify-between">
                  <Link to="/job-details/environmental-engineer" className="inline-block px-4 py-2 border border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-medium rounded-lg transition-colors duration-200 text-sm">View Details</Link>
                  <button className="p-2 text-gray-400 hover:text-primary-600 transition-colors duration-200">
                    <i className="far fa-bookmark"></i>
                  </button>
                </div>
              </div>
            </div>

            {/* Job 2 */}
            <div className="bg-white border border-gray-200 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <img src="https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=80&h=80&q=80" alt="RTA Logo" className="w-12 h-12 rounded-lg" />
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">Transport Planning Specialist</h3>
                      <div className="flex items-center text-gray-600 text-sm">
                        <i className="fas fa-building mr-1"></i> Roads and Transport Authority
                      </div>
                    </div>
                  </div>
                  <span className="inline-block bg-green-100 text-green-800 text-xs font-medium px-2 py-1 rounded-full">Full Time</span>
                </div>

                <div className="space-y-2 mb-4">
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-map-marker-alt mr-2 w-4"></i> Dubai, UAE
                  </div>
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-money-bill-wave mr-2 w-4"></i> AED 18,000 - 25,000
                  </div>
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-clock mr-2 w-4"></i> Posted 1 week ago
                  </div>
                </div>

                <p className="text-gray-700 text-sm mb-4 line-clamp-2">The Roads and Transport Authority (RTA) is looking for a Transport Planning Specialist to join our Strategic Planning Department...</p>

                <div className="flex items-center justify-between">
                  <Link to="/job-details/transport-planning-specialist" className="inline-block px-4 py-2 border border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-medium rounded-lg transition-colors duration-200 text-sm">View Details</Link>
                  <button className="p-2 text-gray-400 hover:text-primary-600 transition-colors duration-200">
                    <i className="far fa-bookmark"></i>
                  </button>
                </div>
              </div>
            </div>

            {/* Job 3 */}
            <div className="bg-white border border-gray-200 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <img src="https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?auto=format&fit=crop&w=80&h=80&q=80" alt="Ministry of Health Logo" className="w-12 h-12 rounded-lg" />
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">Public Health Specialist</h3>
                      <div className="flex items-center text-gray-600 text-sm">
                        <i className="fas fa-building mr-1"></i> Ministry of Health & Prevention
                      </div>
                    </div>
                  </div>
                  <span className="inline-block bg-green-100 text-green-800 text-xs font-medium px-2 py-1 rounded-full">Full Time</span>
                </div>

                <div className="space-y-2 mb-4">
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-map-marker-alt mr-2 w-4"></i> Abu Dhabi, UAE
                  </div>
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-money-bill-wave mr-2 w-4"></i> AED 20,000 - 28,000
                  </div>
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-clock mr-2 w-4"></i> Posted 5 days ago
                  </div>
                </div>

                <p className="text-gray-700 text-sm mb-4 line-clamp-2">The Ministry of Health & Prevention is seeking a qualified Public Health Specialist to join our team...</p>

                <div className="flex items-center justify-between">
                  <Link to="/job-details/public-health-specialist" className="inline-block px-4 py-2 border border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-medium rounded-lg transition-colors duration-200 text-sm">View Details</Link>
                  <button className="p-2 text-gray-400 hover:text-primary-600 transition-colors duration-200">
                    <i className="far fa-bookmark"></i>
                  </button>
                </div>
              </div>
            </div>

            {/* Job 4 */}
            <div className="bg-white border border-gray-200 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <img src="https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?auto=format&fit=crop&w=80&h=80&q=80" alt="DEWA Logo" className="w-12 h-12 rounded-lg" />
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">Electrical Engineer</h3>
                      <div className="flex items-center text-gray-600 text-sm">
                        <i className="fas fa-building mr-1"></i> Dubai Electricity & Water Authority
                      </div>
                    </div>
                  </div>
                  <span className="inline-block bg-green-100 text-green-800 text-xs font-medium px-2 py-1 rounded-full">Full Time</span>
                </div>

                <div className="space-y-2 mb-4">
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-map-marker-alt mr-2 w-4"></i> Dubai, UAE
                  </div>
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-money-bill-wave mr-2 w-4"></i> AED 15,000 - 22,000
                  </div>
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-clock mr-2 w-4"></i> Posted 2 days ago
                  </div>
                </div>

                <p className="text-gray-700 text-sm mb-4 line-clamp-2">DEWA is looking for an experienced Electrical Engineer to join our Power Generation Division...</p>

                <div className="flex items-center justify-between">
                  <Link to="/job-details/electrical-engineer" className="inline-block px-4 py-2 border border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-medium rounded-lg transition-colors duration-200 text-sm">View Details</Link>
                  <button className="p-2 text-gray-400 hover:text-primary-600 transition-colors duration-200">
                    <i className="far fa-bookmark"></i>
                  </button>
                </div>
              </div>
            </div>

            {/* Job 5 */}
            <div className="bg-white border border-gray-200 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <img src="https://images.unsplash.com/photo-1497486751825-1233686d5d80?auto=format&fit=crop&w=80&h=80&q=80" alt="Ministry of Education Logo" className="w-12 h-12 rounded-lg" />
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">Education Policy Analyst</h3>
                      <div className="flex items-center text-gray-600 text-sm">
                        <i className="fas fa-building mr-1"></i> Ministry of Education
                      </div>
                    </div>
                  </div>
                  <span className="inline-block bg-green-100 text-green-800 text-xs font-medium px-2 py-1 rounded-full">Full Time</span>
                </div>

                <div className="space-y-2 mb-4">
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-map-marker-alt mr-2 w-4"></i> Abu Dhabi, UAE
                  </div>
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-money-bill-wave mr-2 w-4"></i> AED 16,000 - 23,000
                  </div>
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-clock mr-2 w-4"></i> Posted 1 week ago
                  </div>
                </div>

                <p className="text-gray-700 text-sm mb-4 line-clamp-2">The Ministry of Education is seeking an Education Policy Analyst to support the development and implementation of education policies...</p>

                <div className="flex items-center justify-between">
                  <Link to="/job-details/education-policy-analyst" className="inline-block px-4 py-2 border border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-medium rounded-lg transition-colors duration-200 text-sm">View Details</Link>
                  <button className="p-2 text-gray-400 hover:text-primary-600 transition-colors duration-200">
                    <i className="far fa-bookmark"></i>
                  </button>
                </div>
              </div>
            </div>

            {/* Job 6 */}
            <div className="bg-white border border-gray-200 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <img src="https://images.unsplash.com/photo-1593115057322-e94b77572f20?auto=format&fit=crop&w=80&h=80&q=80" alt="Dubai Police Logo" className="w-12 h-12 rounded-lg" />
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">Cybersecurity Specialist</h3>
                      <div className="flex items-center text-gray-600 text-sm">
                        <i className="fas fa-building mr-1"></i> Dubai Police
                      </div>
                    </div>
                  </div>
                  <span className="inline-block bg-green-100 text-green-800 text-xs font-medium px-2 py-1 rounded-full">Full Time</span>
                </div>

                <div className="space-y-2 mb-4">
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-map-marker-alt mr-2 w-4"></i> Dubai, UAE
                  </div>
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-money-bill-wave mr-2 w-4"></i> AED 18,000 - 25,000
                  </div>
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-clock mr-2 w-4"></i> Posted 4 days ago
                  </div>
                </div>

                <p className="text-gray-700 text-sm mb-4 line-clamp-2">Dubai Police is seeking a skilled Cybersecurity Specialist to join our Electronic Evidence Department...</p>

                <div className="flex items-center justify-between">
                  <Link to="/job-details/cybersecurity-specialist" className="inline-block px-4 py-2 border border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-medium rounded-lg transition-colors duration-200 text-sm">View Details</Link>
                  <button className="p-2 text-gray-400 hover:text-primary-600 transition-colors duration-200">
                    <i className="far fa-bookmark"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <Link to="/jobs?sector=government" className="inline-block px-8 py-3 bg-primary-600 text-white hover:bg-primary-700 font-semibold rounded-lg transition-all duration-200 transform hover:scale-105">View All Government Jobs</Link>
          </div>
        </div>
      </section>

      {/* Application Guide Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Government Job Application Guide</h2>
            <p className="text-xl text-gray-600">Tips to help you succeed in your government job application</p>
          </div>

          <div className="space-y-8 max-w-4xl mx-auto">
            <div className="flex items-start space-x-6">
              <div className="flex-shrink-0 w-12 h-12 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold text-lg">1</div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Research the Organization</h3>
                <p className="text-gray-600">Understand the government entity's mission, values, and strategic objectives before applying.</p>
              </div>
            </div>

            <div className="flex items-start space-x-6">
              <div className="flex-shrink-0 w-12 h-12 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold text-lg">2</div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Prepare Your Documents</h3>
                <p className="text-gray-600">Ensure your CV, certificates, and identification documents are up-to-date and properly attested.</p>
              </div>
            </div>

            <div className="flex items-start space-x-6">
              <div className="flex-shrink-0 w-12 h-12 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold text-lg">3</div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Highlight Relevant Skills</h3>
                <p className="text-gray-600">Focus on skills and experiences that match the specific requirements of government positions.</p>
              </div>
            </div>

            <div className="flex items-start space-x-6">
              <div className="flex-shrink-0 w-12 h-12 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold text-lg">4</div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Prepare for Assessments</h3>
                <p className="text-gray-600">Many government jobs require written tests, interviews, and assessment centers.</p>
              </div>
            </div>

            <div className="flex items-start space-x-6">
              <div className="flex-shrink-0 w-12 h-12 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold text-lg">5</div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Follow Up Appropriately</h3>
                <p className="text-gray-600">Be patient but proactive in following up on your application status.</p>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <Link to="/government-application-guide" className="inline-block px-8 py-3 border-2 border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-semibold rounded-lg transition-all duration-200 transform hover:scale-105">Read Full Guide</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Government;
